export const CONSTRAINED_PAGE_MAX_WIDTH = '1000px'
export const FOOTER_CONTENT_HEIGHT = '80px'
export const HEADER_CONTENT_HEIGHT = '60px'
export const MENU_PANEL_WIDTH = '240px'
export const MENU_PANEL_WIDTH_EXPANDED = '240px'
export const MENU_PANEL_WIDTH_COLLAPSED = '60px'
export const HIDE_CHROME_STORAGE_KEY = 'hideChrome'
export const MENU_EXPANDED_STORAGE_KEY = 'menuExpanded'
